<template>
  <div class="h-dialogContainer">    
    <DynamicList ref="dynamicList" :list="list" :title="lable.title" :addBtnClick="addBtnClick" :delBtnClick="delBtnClick" :firstFlag="firstFlag">
      <template v-for="item in list" :slot="item.key">
        <form :id='item.formId' :key="item.key">
          <div class='row h-row-inputBox'>
            <div class="h-topo-device-ip">
              <div class="h-inputLit"><span class="h-red-code">* </span>{{lable.ipaddr}}</div> 
              <ejs-textbox name='ipaddr' :placeholder='lable.ipaddr' v-model="item.ipaddr"></ejs-textbox>
            </div>    
            <div class="h-topo-device-port"> 
              <div class="h-inputLit"><span class="h-red-code">* </span>{{lable.port}}</div> 
              <ejs-textbox name='port' :placeholder='lable.port' v-model="item.port"></ejs-textbox>
            </div>
          </div>
        </form>
      </template> 
    </DynamicList>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import DynamicList from './DynamicList';
import { EventBus } from '../../plugins/eventBus';

export default {
  name: "IPAddrList",
  components: {
    DynamicList,
  },
  data() {
    return {
      id: 0,
      list: [],
      firstFlag: 0,
      lable: {
        title: this.$t('Topo.devIpPort'), 
        ipaddr: this.$t('Topo.devIp'),
        port: this.$t('Topo.devPort'),
      },
      listSize: {
        max: 1,
        min: 1,
      },
    };
  },  
  methods: { 
    getDatas() {
      const result = [];
      if (this.validate()) {
        this.list.map((item) => {
          result.push({
            ipaddr: item.ipaddr,
            port: item.port,
            id:item.id,
          })
        }) 
        return result;
      }
      return null;
    },
    validate() {
      let result = true;
      this.list.map((item) => {
        result = result && item.formObj.validate();
      })  
      return result;
    },
    initDatas(args) { 
      console.log('initDatas1',args)   
      this.list=[];
      for(var k in args){
        const key = this.id++;
        this.list.push({
          key: `${key}`,
          formId: `formId_${key}`,
          formObj: null,
          ipaddr: args[k].ip,
          port: args[k].port,
          id:args[k].id,
        });
      }
      console.log('initDatas1',this.list)
      this.firstFlag = parseInt(this.list[0].key);
      setTimeout(() => {
        this.bindValidate();
      }, 200);
    },
    initArgs(args){
      console.log('initArgs1',args)
      const typeCode = args.typeCode;      
      // if( typeCode === 10005 ){3.0版本暂未确定
      //   this.listSize.max = 3;
      // }
      // else{
      //   this.listSize.max = 1;
      // }
      this.listSize.max = 1;//E国ENB定制版本，最多加一个IP
      this.changeListSize(typeCode);
      console.log('initArgs2',this.list.length)
    },
    addBtnClick() {
      console.log('addBtnClick1',this.list)
      if (this.list.length >= this.listSize.max) {     
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.noAddMore')});
        return;
      } 
      const key = this.id++;
      this.list.push({
        key: `${key}`,
        formId: `formId_${key}`,
        formObj: null,
        ipaddr: '',
        port: '',
        id:'',
      });
      console.log('addBtnClick2',this.list)
      this.firstFlag = parseInt(this.list[0].key);
      setTimeout(() => {
        this.bindValidate();
      }, 200);
    },
    bindValidate() {
      const validationOption = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = 'left';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: { 
          ipaddr: {                        
            required: [true, `${this.$t('Pm.alertRequired')}`],
            regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
          },
          port: {
            required: [true, `${this.$t('Pm.alertRequired')}`],
            regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
            range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],
          },
        },
      };
      this.list.map((item) => {
        item.formObj = new FormValidator(`#${item.formId}`, validationOption);
      })   
    },
    delBtnClick(key) {
     //第一对IP和端口不允许删除
      if (key === this.list[0].key) {
         EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.forbidDel')});
        return;
      }

      // if (this.list.length === this.listSize.min) {
      //   this.$layer.warn({ msg: '亲，我也是有底线的哦 ~_~' });
      //   return;
      // } 
      const obj = this.list.find((item) => item.key === key);
      if (obj.id !== '') {
        const id = parseInt(obj.id);
        const This = this;
        This.$axios.get(`/lte/ems/topo/device/deleteIpPort/${id}`).then(response => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          this.list = this.list.filter((item) => item.key !== key);
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
        } }
        });
      } else {
          this.list = this.list.filter((item) => item.key !== key);
      }   
    },
   // 切换设备类型时自动删除list数据
   changeListSize(typeCode) {
      const len = this.list.length;
      console.log('len',len)
      if(len>1&&typeCode !== 10005){
        this.list.splice(1,len-1)
      }
      console.log('this.list',this.list)
    }
  },
};
</script>
